import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { useNavigate } from "@tanstack/react-router";
import { MailOpen } from "lucide-react";
import { ORG_PROJECT_ROUTE_PATH } from "@/lib/org-project-context/constants";

type InvitationsEmptyStateProps = {
  hasFilter: boolean;
  onClearFilter: () => void;
};

export function InvitationsEmptyState({
  hasFilter,
  onClearFilter,
}: InvitationsEmptyStateProps) {
  const navigate = useNavigate({ from: ORG_PROJECT_ROUTE_PATH });

  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-muted">
        <MailOpen className="h-7 w-7 text-muted-foreground" />
      </div>
      <h2 className="mb-1 font-medium text-lg">
        {hasFilter ? "No matching invitations" : "No pending invitations"}
      </h2>
      <p className="mb-5 max-w-sm text-center text-muted-foreground text-sm">
        {hasFilter
          ? "There are no invitations matching your current filter."
          : "When someone invites you to join a project, you'll see it here."}
      </p>
      {hasFilter ? (
        <Button onClick={onClearFilter} type="button" variant="outline">
          Clear filter
        </Button>
      ) : (
        <Button
          onClick={() =>
            navigate({
              to: "./projects",
            })
          }
          type="button"
          variant="outline"
        >
          Go to projects
        </Button>
      )}
    </div>
  );
}
